import { render, staticRenderFns } from "./EnrolmentQuestionEditor.vue?vue&type=template&id=42c88ec2&scoped=true"
import script from "./EnrolmentQuestionEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c88ec2",
  null
  
)

export default component.exports